import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    IonImg,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonButton,
    IonPage,
    IonContent
} from '@ionic/react';
import { LoginForm } from '../components/auth/components/LoginForm';
import { MagicLinkForm } from '../components/auth/components/MagicLinkForm';
import { SocialLogin } from '../components/auth/components/SocialLogin';
import { AuthenticationState, useAuth } from '../components/auth/contexts/AuthContext';

type LoginMethod = 'password' | 'magic-link' | 'social';

export const Login: React.FC = () => {
    const [method, setMethod] = React.useState<LoginMethod>('password');
    const { authState } = useAuth();
    const history = useHistory();
    const location = useLocation();

    // Get the return URL from location state, default to '/'
    const from = (location.state as any)?.from?.pathname || '/';

    // Redirect if already authenticated
    useEffect(() => {
        if (authState == AuthenticationState.AUTHENTICATED) {
            history.replace(from);
        }
    }, [authState, history, from]);

    return (
        <IonPage>
            <IonContent className="ion-padding">
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    minHeight: '100%' 
                }}>
                    <div style={{ width: '100%', maxWidth: '400px' }}>
                        <div className="ion-text-center">
                            {/* Logo */}
                            <IonImg
                                src="/logo.png"
                                alt="LinkSharePro Logo"
                                style={{
                                    width: '200px',
                                    margin: '2rem auto'
                                }}
                            />

                            {/* Method Selector */}
                            <IonSegment
                                value={method}
                                onIonChange={e => setMethod(e.detail.value as LoginMethod)}
                                className="ion-margin-bottom"
                            >
                                <IonSegmentButton value="password">
                                    <IonLabel>Password</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="magic-link">
                                    <IonLabel>Magic Link</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>

                            {/* Login Forms */}
                            {method === 'password' && <LoginForm />}
                            {method === 'magic-link' && <MagicLinkForm />}

                            <div className="ion-padding-top">
                                <IonButton expand="block" fill="clear" routerLink="/register">
                                    Don't have an account? Sign up
                                </IonButton>
                            </div>

                            <div className="ion-text-center ion-padding">
                                <IonLabel>Or continue with</IonLabel>
                            </div>
                            <SocialLogin />
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
}; 